import './App.css';
import Home from './components/home'

function App() {
  return (
    <div style={{width: '100%'}}>
      <Home />
    </div>
  );
}

export default App;
